import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPopupType } from '../../models/modalPopupType';
import { ValueTupleOfStringListOfInt64 } from '@shared/service-proxies/service-proxies';


@Component({
    selector: 'app-modal-popup-invite-user',
    templateUrl: './modal-popup-invite-user.component.html',
    styleUrls: ['./modal-popup-invite-user.component.css']
})
export class ModalPopupInviteUserComponent {
    @ViewChild('template') template: TemplateRef<any>;
    @Output() clickedYes = new EventEmitter<any>();
    @Output() clickedCancel = new EventEmitter<any>();
    @Input() message: string;
    @Input() submessage: string;
    modalType: ModalPopupType;
    modalRef: BsModalRef;
    deleteuserIds: number[] = [];
    config = {
        animated: true,
        class: 'modal-dialog-centered'
    };

    constructor(private bsModalService: BsModalService) { }

    ngOnInit(): void {
    }

    showData(usernames: ValueTupleOfStringListOfInt64 = null) {
        console.log(usernames)
        this.message = usernames?.item1
        this.deleteuserIds = usernames?.item2
        this.modalRef = this.bsModalService.show(this.template, this.config)
    }

    yes() {
        this.clickedYes.emit(this.deleteuserIds);
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }

}


